import axios from "axios";
import { generativeAIAction } from "./generativaAIAction";
import { showSuccessSnackbar } from "../../snackBar/snackBar.action";

const getAdminURL = (state) => {
  return state.environnment.environmentLists.adminBaseURL;
};

export const getAllGenAIAsync = (searchBy, searchText, type) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      let { skip, limit } = getState().genAIData;
      dispatch(generativeAIAction.getAllGenerativeAIStart());
      const { data } = await axios({
        method: "Get",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/generativeAI/getAll?skip=${skip}&limit=${limit}&column=${searchBy}&type=${type}&dir=&search=${searchText}`,
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (data.code === 200) {
        return dispatch(
          generativeAIAction.getAllGenerativeAISuccess(data.data)
        );
      }
      dispatch(generativeAIAction.getAllGenerativeAIError());
      return dispatch(showSuccessSnackbar("success", data.message, 3000));
    } catch (error) {
      console.log(error);
      dispatch(generativeAIAction.getAllGenerativeAIError());
      dispatch(showSuccessSnackbar("error", "Error while fetching data", 3000));
    }
  };
};

export const getGenAIAsync = (id) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      dispatch(generativeAIAction.getGenerativeAIStart());
      const { data } = await axios({
        method: "Get",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/generativeAI/getGenerateAI/${id}`,
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (data.code === 200) {
        return dispatch(generativeAIAction.getGenerativeAISuccess(data.data));
      }
      dispatch(generativeAIAction.getGenerativeAIError());
      return dispatch(showSuccessSnackbar("success", data.message, 3000));
    } catch (error) {
      console.log(error);
      dispatch(generativeAIAction.getGenerativeAIError());
      dispatch(showSuccessSnackbar("error", "Error while fetching data", 3000));
    }
  };
};

export const deleteGenAIAsync = (id) => {
  return async (dispatch, getState) => {
    try {
      const dataarra = [id];
      const adminBaseURL = getAdminURL(getState());
      dispatch(generativeAIAction.deleteGenerativeAIStart());
      const { data } = await axios({
        method: "post",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/generativeAI/deleteSelectedQuote/`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          data: dataarra,
        },
      });
      if (data.code === 200) {
        return dispatch(generativeAIAction.deleteGenerativeAISuccess(data.data));
      }
      dispatch(generativeAIAction.deleteGenerativeAIError());
      return dispatch(showSuccessSnackbar("success", data.message, 3000));
    } catch (error) {
      console.log(error);
      dispatch(generativeAIAction.deleteGenerativeAIError());
      dispatch(showSuccessSnackbar("error", "Error while fetching data", 3000));
    }
  };
};

export const deleteSelectedGenAIQuote = (id) => {
  return async (dispatch, getState) => {
    try {
      const idsArray = id;
      const adminBaseURL = getAdminURL(getState());
      dispatch(generativeAIAction.deleteMultipleGenerativeAIStart());
      const { data } = await axios({
        method: "post",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/generativeAI/removeMultiQuote/`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          ids: idsArray,
        },
      });
      if (data.code === 200) {
        return dispatch(generativeAIAction.deleteMultipleGenerativeAISuccess(data.data));
      }
      dispatch(generativeAIAction.deleteMultipleGenerativeAIError());
      return dispatch(showSuccessSnackbar("success", data.message, 3000));
    } catch (error) {
      console.log(error);
      dispatch(generativeAIAction.deleteMultipleGenerativeAIError());
      dispatch(showSuccessSnackbar("error", "Error while fetching data", 3000));
    }
  };
};
